<style lang="scss" scoped>
img {
  max-width: 100%;
}
.img-mod {
  max-height: 150px;
  max-width: 300px;
}
</style>

<template>
  <span>
    <img
      @load="$bus.$emit('new-message')"
      :src="message.meta.url"
      @click="$modal.show('image-modal', { image: message.meta.url })"
      :class="{ 'img-mod': moderation }"
    />
  </span>
</template>

<script>
export default {
  props: ["message", "moderation"]
};
</script>
